//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import headerSearch from  '../components/header-search'
import contactUs from '../components/contact-us'

import instance from '../assets/js/instance'
import { Toast } from 'vant'


export default {
  data () {
    return {
      baseUrl: process.env.BASE_URL,
      id: '',
      pid: '',
      name: '',
      showBuy: false,
      swiperList: [],
      buyList: [],
      remark: '',
      showContact: false
    }
  },
  computed: {
    options () {
      return this.$t('detail')
    },
    path () {
      return this.$store.getters.getPath
    },

    cMenu() {
      return this.$t("cMenu");
    },

    isPhone() {
      return this.$store.getters.getIsPhone;
    }
  },
  watch: {
    showBuy (val) {
      if (val) {
        window.addEventListener('click', this.hideBuy)
      } else {
        window.removeEventListener('click', this.hideBuy)

      }
    }
  },
  components: {
    headerSearch,
    contactUs
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },

    hideBuy () {
      this.showBuy = false
    },

    getInfo () {
      this.showToast()
      instance.get('/api/goods/getGoodsDetail?id=' + this.id).then(res => {
        let data = res.data
        if (data.code === 0) {
          console.log(data)
          let obj = data.data.list
          this.pid = obj.brand_id
          this.swiperList = obj.img
          this.name = obj.name
          this.buyList = obj.channel
          this.remark = obj.remark

          this.$nextTick(() => {
            if (!this.isPhone) {
              var mySwiper = new Swiper(".swiper-container", {
                clickable: true,
                loop: true, // 循环模式选项
                autoplay: {
                  autoplay: true,
                  delay: 3000
                },
                // 如果需要分页器
                pagination: {
                  el: ".swiper-pagination",
                  clickable: true,
                }
              });
            }
          });
        }
        this.clearToast()
      }).catch(e => {
        console.log(e)
        this.clearToast()
      })
    },

     showToast () {
      Toast.loading({
        duration: 0,
        mask: true,
        message: this.options.loading
      })
    },

    clearToast () {
      Toast.clear()
    },

    showTact () {
      this.showContact = true
    },

    closeTact () {
      this.showContact = false
    },
    
    init () {
      if (!instance.defaults.headers.language) {
        return false
      }
      let id = ''
      let pid = ''
      if (this.$route.query.id) {
        id = this.$route.query.id
      }
      if (this.$route.query.pid) {
        pid = this.$route.query.pid
      }
      this.id = id
      this.pid = pid
      this.getInfo()
    },
  },
  mounted () {
    this.init()
    window.subscribe.listen('languageChange', () => {
      this.init()
    })
  }
}
